<template>
    <div class="xieyi_fenlei">
        <div class="xieyi_neirong">
            <p class="biaoti-xieyi">《酷皮音乐服务条款》</p>
            <div class="wenzi_zhenduo">

<br/>一、服务的使用

<br/>1.欢迎使用酷皮音乐服务（以下简称 “本服务”）。本服务由酷皮音乐团队提供，旨在为用户提供音乐播放、下载、搜索、收藏以及个性化推荐等功能。用户在使用本服务时，应遵守本服务条款及相关法律法规。
<br/>2.为了使用本服务，您可能需要注册一个账户。您保证在注册过程中提供的信息真实、准确、完整，并将及时更新您的信息，确保其持续有效。您对您的账户和密码的安全性负责，对于因您的账户信息泄露而导致的任何后果，本服务不承担责任。

<br/><br/>二、服务的可用性和变更

<br/>1.本服务将尽力确保其可用性，但不保证服务不会中断或出现错误。由于网络故障、服务器维护、升级、不可抗力等因素，可能会导致服务暂时不可用或部分功能受限，我们将尽力减少此类情况的发生，但对此不承担责任。
<br/>2.酷皮音乐有权在不通知用户的情况下，对服务进行修改、更新、升级或暂停，包括但不限于功能、界面、服务条款等方面的变更。您继续使用本服务即视为接受这些变更。

<br/><br/>三、用户行为规范

<br/>1.您同意在使用本服务时遵守法律法规，不得利用本服务从事任何违法、违规、侵犯他人权利或违反公序良俗的活动，包括但不限于：
<br/>1.上传、传播、分享包含淫秽、色情、暴力、恐怖、歧视、诽谤、侵权、虚假信息等内容的音乐或其他信息。
<br/>2.对本服务进行逆向工程、破解、篡改、攻击或干扰服务的正常运行。
<br/>3.以任何方式侵犯其他用户或第三方的知识产权，包括但不限于音乐作品的版权、商标权、专利权等。
<br/>4.通过本服务进行垃圾邮件发送、广告骚扰或其他未经授权的商业活动。
<br/>2.您仅可将本服务用于个人的非商业目的，未经酷皮音乐的书面许可，不得将本服务用于商业运营或其他商业行为。

<br/><br/>四、音乐内容

<br/>1.酷皮音乐尊重音乐作品的版权，本服务上的音乐内容由酷皮音乐通过合法渠道获取或获得相应授权。然而，我们不保证所有音乐的版权信息的完整性和准确性，对于因版权问题引发的纠纷，我们将配合相关方进行调查和处理，但不承担最终的法律责任。
<br/>2.您可以在本服务允许的范围内收听、下载和使用音乐，但不得将下载的音乐进行非法传播、转售或用于其他商业目的。未经授权的复制、分发、公开表演或改编音乐作品是被严格禁止的。

<br/><br/>五、隐私保护

<br/>1.酷皮音乐重视用户的隐私，将按照隐私政策保护您的个人信息。请阅读我们的隐私政策，了解我们如何收集、使用、存储、保护和分享您的信息。
<br/>2.您同意酷皮音乐在提供服务的过程中，收集和使用您的信息，包括但不限于用户注册信息、使用记录、偏好信息等，以优化服务体验、提供个性化推荐和解决可能出现的问题。

<br/><br/>六、付费服务和订阅

<br/>1.酷皮音乐可能提供部分付费服务和订阅功能，如高级会员、付费音乐下载等。在使用付费服务时，您应按照页面提示完成支付流程，支付相应的费用。
<br/>2.对于付费服务，我们将明确标明服务的价格、内容和服务期限。一旦您支付成功，除法律规定的特殊情况外，一般不提供退款。
<br/>3.如您的付费服务因服务中断或其他原因受到影响，我们将根据具体情况进行相应的处理，包括但不限于延长服务期限、提供补偿或其他合理的解决方案。

<br/><br/>七、免责声明

<br/>1.本服务仅作为一个音乐服务平台，对用户使用服务产生的任何直接或间接的损失，包括但不限于数据丢失、设备损坏、利润损失、业务中断等，不承担责任。
<br/>2.对于因第三方服务提供商的原因导致的服务问题或损失，我们将尽力协助解决，但不承担最终责任。

<br/><br/>八、终止服务

<br/>1.酷皮音乐有权在以下情况下终止您的服务：
<br/>1.您违反本服务条款或相关法律法规。
<br/>2.您的账户长时间未使用，我们有权根据具体情况决定是否终止服务。
<br/>3.因业务调整或其他原因，酷皮音乐有权终止部分或全部服务。
<br/>2.服务终止后，您将无法再使用相应的服务功能，但您可能仍然需要遵守本服务条款中的其他规定，如隐私保护、版权责任等。

<br/><br/>九、法律适用和争议解决

<br/>1.本服务条款受 [具体法律管辖地区] 法律的管辖。
<br/>2.因本服务条款产生的任何争议，应首先通过友好协商解决；协商不成的，可提交 [具体的仲裁机构或法院] 进行仲裁或诉讼。

<br/>以上服务条款仅供参考，旨在保护酷皮音乐平台的正常运营和用户的合法权益。在使用此服务条款前，建议咨询专业的法律人士，确保其符合当地的法律法规和业务需求。如果你还有其他具体的需求，比如加入某些特殊的服务条款或对某些条款进行细化，可以随时告诉我，我会为你提供更专业的帮助。


            </div>
        </div>
    </div>
</template>
<script>
// 服务协议
export default {

}
</script>
<style lang="scss" scoped>
.xieyi_fenlei {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .xieyi_neirong {
        width: 1200px;
        // background-color: antiquewhite;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 30px;

        .biaoti-xieyi {
            font-size: 23px;
            font-family: YuanTi;
            font-weight: bold;
            margin-bottom: 20px;
            color: var(--them-color);
        }

        .wenzi_zhenduo {
            font-size: 16px;
            font-family: YuanTi;
            color: var(--xieyi-size);
            line-height: 33px;
            padding-bottom: 20px;
            white-space: pre-wrap;
            word-wrap: break-word;
            word-break: break-all;
        }
    }
}
</style>